import loadMore from './purpose/loadMore.vue'
import scroll from './purpose/scroll.vue'
import bomb from './purpose/bomb.vue'
import slide from './purpose/slide.vue'
import goods from './purpose/goods.vue'
import goods1 from './purpose/goods1.vue'
import sphereViewer from './purpose/sphereViewer.vue'
import lazyImage from './purpose/lazyImage.vue'


function plugins(Vue) {
  Vue.component("bomb", bomb); //弹窗组件
  Vue.component("loadMore", loadMore); //加载组件
  Vue.component("scroll-view", scroll); //滚动组件
  Vue.component("slide-view", slide); //滑动条组件
  Vue.component("goods-view", goods); //商品列表组件
  Vue.component("goods1-view", goods1); //商品列表组件
  Vue.component("sphereViewer", sphereViewer); //预览组件
  Vue.component("lazyImage", lazyImage); //图片懒加载
}



export default plugins
